import React from "react";
import { Box, Stack, Typography, Collapse } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { sxSectionTitle, sectionHeaderButtonSx } from "./styles";

export function TicketDetailsSection({ title, open, onToggle, children }) {
  return (
    <Box sx={{ borderBottom: "1px solid #F1F3F5" }}>
      <Box component="button" type="button" onClick={onToggle} sx={sectionHeaderButtonSx}>
        <Typography component="span" sx={sxSectionTitle}>
          {title}
        </Typography>
        {open ? (
          <ExpandMoreIcon sx={{ fontSize: 22, color: "#405261" }} />
        ) : (
          <ChevronRightIcon sx={{ fontSize: 22, color: "#405261" }} />
        )}
      </Box>
      <Collapse in={open} unmountOnExit>
        <Stack gap={1.5} sx={{ pb: 2, pt: 0.5, width: 248 }}>
          {children}
        </Stack>
      </Collapse>
    </Box>
  );
}
